import { Component, OnInit } from '@angular/core';
import {Location} from "@angular/common";
import {UploadsAdminService} from "../../services/uploads-admin.service";
import {BankTransferLoad} from "../../../dto/bankTransferLoad";
import {toDateTimeString} from "../../../providers/app-date-adapter";
import {LoadRiskFlags} from "../../../dto/loadRiskFlags";
import * as moment from "moment";
import {DataListModel} from "../../../models/data-list-model";
import {ContentRowField} from "../../../shared/content-row/content-row.component";
import {CashbackGroupMembership} from "../../../dto/cashbackGroup";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.css']
})
export class ImagesComponent implements OnInit {
  isLoading = false;
  uploadAlbums: string[];

  constructor(
    private location: Location,
    private uploadsAdminService: UploadsAdminService,
    private router: Router,
    private route: ActivatedRoute,
    ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.uploadsAdminService.getAlbums().subscribe(albums => {
      this.uploadAlbums = albums;
      this.isLoading = false;
    });
  }

  returnBack() {
    this.location.back();
  }


  goToAlbum(albumId: string) {
    this.router.navigate([albumId], {relativeTo: this.route});
  }
}
